import { Menu, MenuItem, Typography } from "@mui/material";
import { useContext } from "react";
import { UserDetailsContext } from "../Context/userDetailsContext";
import axios from "../axiosConfig";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";

const SettingsMenu = ({ open, handleClose, anchorEl }) => {
    const { setUserDetails } = useContext(UserDetailsContext);
    const nav = useNavigate();
    const { t } = useTranslation();

    const onLogout = async () => {
        try {
            // Make a request to the logout endpoint on your server
            await axios.post('/Auth/logout', {}, {
                withCredentials: true
            });
            
            // Clear all user data from context
            setUserDetails({});
            
            // Clear localStorage
            localStorage.clear();
            
            // Clear sessionStorage
            sessionStorage.clear();
            
            handleClose(); // Close the menu
            
            // Navigate to login and reload
            window.location.href = "/login";
        } catch (error) {
            console.log('Logout failed:', error);
            
            // Still clear user details and redirect even if API fails
            setUserDetails({});
            localStorage.clear();
            sessionStorage.clear();
            handleClose();
            window.location.href = "/login";
        }
    };

    const onMyAccountClick = () => {
        handleClose(); // Close the menu
        nav("/my-account"); // Navigate to the "My Account" page
    };
    
    return (
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
        >
            <MenuItem onClick={onMyAccountClick}>
                <Typography>{t('nav_myAccount')}</Typography>
            </MenuItem>
            <MenuItem onClick={onLogout}>
                <Typography>{t('logout')}</Typography>
            </MenuItem>
        </Menu>
    );
};

export default SettingsMenu;
